/**
 * Het nieuwsoverzicht op de gedeelde archiefmachinerie zetten.
 *
 * Eén as: de categorie. De knoppen zijn radio's, dus er staat er hooguit één aan --
 * ArchiveNews leest ?category= dan ook als één slug. De blade splitst hem nog op komma's,
 * een rest uit de tijd dat dit selectievakjes waren; zolang het radio's zijn levert dat
 * dezelfde ene waarde op.
 *
 * Anders dan bij projecten wordt er bij binnenkomst niet naar de lijst gescrold: de
 * filterbalk staat hier in de paginakop, en daar hoor je bovenaan te beginnen.
 */

import initArchiveFilter, { setParam } from './archive-filter';

export default function initNewsFilter() {
  initArchiveFilter({
    filter: '[data-news-filter]',
    results: '[data-news-results]',
    option: '[data-category-option]',
    all: '[data-category-all]',
    controls: '.news-checkbox',

    buildUrl(url, filter) {
      const checked = filter.querySelector('.news-checkbox:checked');

      setParam(url, 'category', checked ? checked.value : '');
    },

    describe: (count) => {
      if (count === 0) {
        return 'Geen berichten gevonden.';
      }

      return count === 1 ? '1 bericht gevonden.' : `${count} berichten gevonden.`;
    },
  });
}
